class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => { event.preventDefault(); this.open(cartLink); });
    cartLink.addEventListener('keydown', (event) => { if (event.code.toUpperCase() === 'SPACE') { event.preventDefault(); this.open(cartLink); } });
  }
  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => { this.classList.add('animate', 'active'); });
    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });
    document.body.classList.add('overflow-hidden');
    this.querySelector('cart-drawer-items')?.dispatchViewEvent();
  }
  close() { this.classList.remove('active'); removeTrapFocus(this.activeElement); document.body.classList.remove('overflow-hidden'); }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');
    if (cartDrawerNote.nextElementSibling.getAttribute('id')) cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    cartDrawerNote.addEventListener('click', (event) => { event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open')); });
    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }
  renderContents(parsedState) {
    this.classList.toggle('is-empty', parsedState.item_count === 0);
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    setTimeout(() => { this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this)); this.open(); });
  }
  getSectionInnerHTML(html, selector = '.shopify-section') { return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML; }
  getSectionsToRender() { return [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }]; }
  getSectionDOM(html, selector = '.shopify-section') { return new DOMParser().parseFromString(html, 'text/html').querySelector(selector); }
  setActiveElement(element) { this.activeElement = element; }
}
customElements.define('cart-drawer', CartDrawer);
class CartDrawerItems extends CartItems {
  getSectionsToRender() { return [{ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' }, { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }]; }
}
customElements.define('cart-drawer-items', CartDrawerItems);

/* SRH — FREE GIFT DOWNGRADE SAFETY */
(function () {
  let timer = null;
  let busy = false;
  function isGift(item) {
    return item && item.properties && (item.properties._srh_gift === 'gift1' || item.properties._srh_gift === 'gift2');
  }
  function qualifyingTotal(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      if (isGift(item)) return sum;
      return sum + (Number(item.original_line_price) || 0);
    }, 0);
  }
  async function enforceGiftThresholds() {
    if (busy) return;
    busy = true;
    try {
      const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) return;
      const cart = await cartResponse.json();
      const total = qualifyingTotal(cart);
      const updates = {};
      (cart.items || []).forEach(function (item) {
        const type = item.properties && item.properties._srh_gift;
        if (type === 'gift2' && total < 10000) updates[item.key] = 0;
        if (type === 'gift1' && total < 7500) updates[item.key] = 0;
      });
      if (!Object.keys(updates).length) return;
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
      });
      if (!response.ok) return;
      const state = await response.json();
      const drawer = document.querySelector('cart-drawer');
      if (drawer && state.sections && typeof drawer.renderContents === 'function') drawer.renderContents(state);
      document.dispatchEvent(new CustomEvent('srh:cart-updated'));
    } catch (error) {
      console.warn('SRH gift downgrade safety:', error);
    } finally { busy = false; }
  }
  function schedule(delay) { clearTimeout(timer); timer = setTimeout(enforceGiftThresholds, delay || 500); }
  document.addEventListener('click', function (event) {
    if (event.target.closest('.quantity__button, cart-remove-button, [name="plus"], [name="minus"]')) {
      schedule(650);
      setTimeout(function () { schedule(250); }, 1200);
    }
  }, true);
  document.addEventListener('change', function (event) {
    if (event.target.matches('.quantity__input, input[name="updates[]"]')) schedule(650);
  }, true);
  ['cart:updated', 'cart:refresh'].forEach(function (name) {
    document.addEventListener(name, function () { schedule(500); });
  });
})();
